<template>
    <div class="city-card" @click="toPage">
        <div class="city-card-content">
            <img class="city-card-img" :src="`/api/v1/file/${url}`" alt="">
        </div>
        <div class="city-card-name">{{name}}</div>
    </div>
</template>

<script>
    export default {
        name: "CityCard",
        props:{
            url: {
                type: String,
                default: ''
            },
            name: {
                type: String,
                default: ''
            }
        },
        methods:{
            toPage(){
                this.$router.push({path: '/hotCity', query:{name: this.name}})
            }
        }
    }
</script>

<style scoped lang="less">
    .city-card{
        width: 244px;
        height: 370px;
        padding: 10px;
        box-sizing: border-box;
        .city-card-content{
            width: 100%;
            height: 310px;
            border-radius: 6px;
            background-color: #e44646;
            overflow: hidden;
            box-shadow: 4px 4px 4px rgb(148, 148, 148);
        }
        .city-card-img{
            width: 100%;
            height: 310px;
            border-radius: 6px;
            object-fit: cover;
            transition: 0.3s;
        }
        .city-card-name{
            color: #333;
            height: 34px;
            line-height: 34px;
            font-size: 22px;
            font-weight: bold;
            text-align: center;
            margin-top: 10px;
        }
        &:hover{
            .city-card-img{
                transform: scale(1.1);
            }
            .city-card-name{
                color: #e44646;
            }
        }
    }
</style>
